




import { Component, Vue } from "vue-property-decorator";
import Bulletins from "@/components/Bulletins.vue"; // @ is an alias to /src

@Component({
  components: {
    Bulletins
  }
})
export default class BulletinsPage extends Vue {}
